<template>
  <section>
    <Title :title-name="title.SelectManualService.titleName" :title-link="title.SelectManualService.titleLink" />
    <div class="select_manual_service">
      <div class="container" style="margin-top: 14pt">
        <p>Dear {{ pax.title }}&nbsp;{{ pax.first_name }}&nbsp;{{ pax.last_name }},</p>
        <div>
          <p>
            We did not find a suitable alternative for you today. Therefore we would like to offer you an alternative solution. As
            your destination is within Germany we can offer you a train ticket or rental car to travel to your destination
          </p>
          <p>
            OR you can choose to stay overnight in an hotel and in that case we will continue our search for the first possible
            option to rebook you on an other flight.
          </p>
          <p>Apologies for the inconvenience</p>
        </div>
      </div>
      <div v-if="SelectManualService[2]">
        <div class="block-item">
          <div class="container">
            <h2 class="title sb_mobile sb_refreshment" style="font-size: 16pt; padding-left: 45pt; width: 100%; margin: 0">
              Refreshment {{ SelectManualService[2].currency }} {{ SelectManualService[2].price_per_person }}
            </h2>
          </div>
        </div>
        <div class="container">
          <div class="block_div">
            <div class="pd10 option2 block_div text-right" style="margin: 14pt 0">
              <button class="btn btnExpand pull-right" @click="btnExpand">
                <span>{{ txtChange }}</span
                >&nbsp;
                <i class="fa" :class="[arrowClass]" aria-hidden="true"></i>
              </button>
            </div>
            <div v-if="!isHidden" class="content-section-wrap">
              <div class="description-wrap">
                <p>
                  We have issued a {{ SelectManualService[2].currency }} {{ SelectManualService[2].price_per_person }} creditcard
                  for your convenience
                </p>
                <p>This creditcard will be valid until.</p>
                <p>
                  Date <span v-if="Rebook">{{ moment(Rebook.date).format('DD-MM-YYYY') }}</span> time
                  <span v-if="Rebook">{{ moment(Rebook.date).format('HH:mm') }}</span> and it can be used at the food and beverage
                  outlets at the airport.
                </p>
              </div>
              <CreditCard></CreditCard>
            </div>
          </div>
        </div>
      </div>
      <div v-if="Object.keys(SelectManualService).length > 0">
        <div class="block-item">
          <div class="container">
            <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0">Select your service</h2>
          </div>
        </div>
        <div v-if="SelectManualService[4]">
          <div class="container">
            <p>
              We offer you the option to take a taxi voucher of {{ airline.currency }} 50,- for transportation to the place of
              your choice
            </p>
            <a class="btnOrange sb_mobile sb_taxi" @click="autoRemoveSer(SelectManualService[4])">
              Yes, I would like 50 {{ airline.currency }} creditcard to use for transportation
            </a>
          </div>
        </div>
        <div v-if="SelectManualService[5]">
          <div v-if="canShowOr" class="block-item">
            <div class="container">
              <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0; text-align: center">OR</h2>
            </div>
          </div>
          <div class="container">
            <p>
              We offer you the option travel to <span v-if="Rebook">{{ Rebook.to_airport_country }}</span> by Train
            </p>
            <a class="btnOrange sb_mobile sb_train" @click="autoRemoveSer(SelectManualService[5])">
              Yes, I would like to travel by Train
            </a>
          </div>
        </div>
        <div v-if="SelectManualService[6]">
          <div v-if="canShowOr" class="block-item">
            <div class="container">
              <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0; text-align: center">OR</h2>
            </div>
          </div>
          <div class="container">
            <p>We offer you the option for rental car to drive to your destination</p>
            <a class="btnOrange sb_mobile sb_car" @click="autoRemoveSer(SelectManualService[6])">
              Yes, I would like a rental car
            </a>
          </div>
        </div>
        <div v-if="SelectManualService[1] && loadDataPaxsGroup">
          <div v-if="canShowOr" class="block-item">
            <div class="container">
              <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0; text-align: center">OR</h2>
            </div>
          </div>
          <div class="container">
            <p>We offer you the option to for a hotel overnight near the airport</p>
            <a class="btnOrange sb_mobile sb_hotel" @click="autoRemoveSer(SelectManualService[1])">
              Yes, I would like a hotel overnight for tonight
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CreditCard from '@/components/CreditCard/index'
import '@/assets/scss/modules/SelectManualService.scss'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import Title from '@/components/Title/index'
import moment from 'moment'

export default {
  name: 'SelectManualService',
  components: { CreditCard, Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isHidden: true,
      txtChange: 'Click to expand',
      arrowClass: 'fa-chevron-down',
      canShowOr: true,
      loadingPaxsGroup: false
    }
  },
  computed: {
    ...mapGetters({
      SelectManualService: 'SelectManualService/SelectManualService',
      Rebook: 'SelectManualService/Rebook',
      PaxsGroup: 'SelectManualService/PaxsGroup'
    }),
    loadDataPaxsGroup: function () {
      return this.loadingPaxsGroup
    }
  },
  watch: {
    PaxsGroup: function () {
      this.loadingPaxsGroup = true
    }
  },
  mounted() {
    this.$store.dispatch('SelectManualService/getSelectManualService')
    this.$store.dispatch('SelectManualService/getRebook')
    this.$store.dispatch('SelectManualService/getPaxsGroup')
    if (Object.keys(this.SelectManualService).length > 0) {
      if (Object.keys(this.SelectManualService).length < 2) {
        this.canShowOr = false
      }
    }
  },
  methods: {
    replaceStr,
    btnExpand: function () {
      this.isHidden = !this.isHidden
      if (this.isHidden) {
        this.txtChange = 'Click to expand'
        this.arrowClass = 'fa-chevron-down'
      } else {
        this.txtChange = 'Click to close'
        this.arrowClass = 'fa-chevron-up'
      }
    },
    autoRemoveSer(ser) {
      let dataRemoveSer = {
        service_id: ser.service_id,
        pax_ids: _.map(this.PaxsGroup, 'passenger_id')
      }
      this.$store.dispatch('SelectManualService/removeService', dataRemoveSer).then((response) => {
        if (response.success) {
          if (ser.service_id == 1) {
            this.hasLeader()
          } else {
            window.location.href = '/home?secret=' + this.secret
          }
        }
      })
    },
    hasLeader() {
      if (!this.PaxsGroup) {
        return
      }
      var isNoNumberPhone = _.find(this.PaxsGroup, function (obj) {
        return _.isEmpty(obj.phone_number) && _.isEmpty(obj.phonenumber_ssr)
      })

      this.searchHotel()
    },
    searchHotel() {
      if (
        this.PaxsGroup.length == 1 ||
        (this.SelectManualService[1].params != null &&
          typeof this.SelectManualService[1].params.matrix_share_room !== 'undefined')
      ) {
        let dataSearchHotel = {
          flight_date: moment(this.pax.flight_date).format('YYYY-MM-DD'),
          secret: this.secret,
          aRoomNeed: {
            s_room: 0,
            sd_room: 0,
            t_room: 0,
            q_room: 0
          }
        }
        if (this.PaxsGroup.length == 1) {
          dataSearchHotel.aRoomNeed.s_room++
        } else {
          let listPaxs = _.groupBy(this.SelectManualService[1].params.matrix_share_room, function (o) {
            return o.room
          })
          _.each(listPaxs, function (t) {
            switch (t.length) {
              case 1:
                dataSearchHotel.aRoomNeed.s_room++
                break
              case 2:
                dataSearchHotel.aRoomNeed.sd_room++
                break
              case 3:
                dataSearchHotel.aRoomNeed.t_room++
                break
              case 4:
                dataSearchHotel.aRoomNeed.q_room++
                break
              default:
                break
            }
          })
        }
        this.$store.dispatch('HotelBook/searchHotels', dataSearchHotel).then((response) => {
          this.bookHotel(response)
        })
      } else {
        window.location.href = 'hotel-book?secret=' + this.secret
      }
    },
    bookHotel(responseHotel) {
      if (
        (responseHotel.reservation && responseHotel.reservation[0].reservations.length == 1) ||
        (responseHotel.list_hotel && responseHotel.list_hotel.length == 1)
      ) {
        let dataBook = {}

        if (responseHotel.reservation) {
          // Book reservation
          dataBook = {
            date: moment(this.pax.flight_date).format('YYYY-MM-DD'),
            secret: this.secret,
            room_id: responseHotel.reservation[0].reservations[0].room_id,
            hotel_id: responseHotel.reservation[0].reservations[0].hotel_id,
            reservations: _.map(responseHotel.reservation[0].reservations, function (o) {
              return {
                id: o.id,
                selected_mealplan: false,
                selected_lunch: false,
                selected_breakfast: false
              }
            })
          }
        } else {
          // Book partner
          dataBook = {
            date: moment(this.pax.flight_date).format('YYYY-MM-DD'),
            secret: this.secret,
            room_id: responseHotel.list_hotel[0].id,
            hotel_id: responseHotel.list_hotel[0].hotel_id
          }
        }
        this.$store.dispatch('HotelList/bookListHotel', dataBook).then((res) => {
          if (typeof res.is_research_hotel !== 'undefined' && res.is_research_hotel === true) {
            window.location.href = '/hotel-list?secret=' + this.secret
            return
          }
          if (res.success) {
            window.location.href = 'home?secret=' + this.secret
          }
        })
      } else if (responseHotel && responseHotel.length == 0) {
        this.$router.push({ path: '/no-hotels-available', query: { secret: this.secret } })
      } else {
        window.location.href = '/hotel-list?secret=' + this.secret
      }
    }
  }
}
</script>
